import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  TablePagination,
  TableFooter,
  Typography,
  IconButton
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';


const useStyles = makeStyles((theme) => ({
  image: {
    height: '50px',
    width: 'auto'
  },
  head: {
    '& .MuiTableCell-head': {
      borderBottomColor: 'rgba(0,0,0,0.6)'
    }
  },
  noResults: {

  },
  row: {
    '&$tableRowHover:hover': {
      backgroundColor: theme.palette.primary[50],
      cursor: 'pointer'
    }
  },
  tableRowHover: {
    // Needed to override hover, even if it is empty
  }
}));

const ItemList = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  if(!props.items || !props.items.length) {
    if(props.showNoResultsMessage) {
      return (
        <div className={classes.container}>
          <Typography variant="subtitle1" component="p" align="center">{t('itemSearch:noResults')}</Typography>
        </div>
      );
    } else {
      return null;
    }
  }

  const visibleRows = props.items.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <TableContainer>
      <Table>
        <TableHead className={classes.head}>
          <TableRow>
            <TableCell></TableCell>
            <TableCell><Typography variant="overline">{t('item:family')}</Typography></TableCell>
            <TableCell><Typography variant="overline">{t('item:tyreClass')}</Typography></TableCell>
            <TableCell><Typography variant="overline">{t('item:itemCode')}</Typography></TableCell>
            <TableCell><Typography variant="overline">{t('item:itemName')}</Typography></TableCell>
            <TableCell><Typography variant="overline">{t('item:itemLifeCycle')}</Typography></TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {visibleRows.map((row) => {
            const thumbnail = row.imageMain?.thumbnail || row.itemFamilyImage?.thumbnail;
            return (
              <TableRow key={row.itemCode} classes={{root: classes.row, hover: classes.tableRowHover}} hover onClick={() => history.push(row.link)}>
                <TableCell align="center">{thumbnail ? <img src={thumbnail} alt="" className={classes.image} /> : null}</TableCell>
                <TableCell>{row.itemFamilyName}</TableCell>
                <TableCell>{row.tyreClass}</TableCell>
                <TableCell>{row.itemCode}</TableCell>
                <TableCell>{row.itemName}</TableCell>
                <TableCell>{row.itemLifeCycle}</TableCell>
                <TableCell align="right">
                  <IconButton color="primary" component={RouterLink} to={row.link}>
                    <EditIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[25, 50, 75, 100]}
              colSpan={7}
              count={props.items.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            //ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

ItemList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  showNoResultsMessage: PropTypes.bool
}

export default ItemList;
